// "EXPIRES TODAY" / "EXPIRED YESTERDAY" / "EXPIRES IN 10D" / "EXPIRED 5D
// AGO" for the dashboard's lease and certification alerts.
//
// Counts CALENDAR days, not elapsed milliseconds rounded to days — the old
// Math.round((date - now) / 86400000) produced "EXPIRED 0D AGO" for
// something expiring today and "1D AGO" for yesterday. Expiry dates are
// calendar dates (entered via date inputs, stored at UTC midnight), so the
// stored date is read in UTC and compared with the viewer's local today.
export function calendarDaysUntil(dateValue, now = new Date()) {
  const d = new Date(dateValue);
  const target = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86400000);
}

export default function expiryLabel(dateValue, t, now = new Date()) {
  const days = calendarDaysUntil(dateValue, now);
  if (days === 0) return t("dashboard.alerts.expiresToday");
  if (days === 1) return t("dashboard.alerts.expiresTomorrow");
  if (days === -1) return t("dashboard.alerts.expiredYesterday");
  if (days < 0) return t("dashboard.alerts.expiredDaysAgo", { count: -days });
  return t("dashboard.alerts.expiresInDays", { count: days });
}
